<template>
  <section style="height: 100%" class="d-flex align-center">
    <v-container>
      <v-row class="d-flex justify-center">
        <v-col cols="11" md="5" class="pa-0">
          <v-card class="pa-3">
            <div class="d-flex flex-wrap">
              <v-sheet class="pa-7 mt-n7 primary text-center box-shadow" dark width="100%">404 Not found</v-sheet>
            </div>
            <v-card-text>
              Required page not found
            </v-card-text>

            <v-card-actions class="justify-center">
              <v-btn color="primary" @click="$router.back()">Back</v-btn>
              <v-btn color="primary" :to="{name: 'Profile'}">Home</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {

}
</script>